import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { BusinessGoal } from '@content/home/business-goal/business-goal.type';
import { NgOptimizedImage } from '@angular/common';
import { AssetPipe } from '@shared/asset/asset.pipe';
import { BusinessGoalButtonsComponent } from '@content/home/business-goal/business-goal-buttons/business-goal-buttons.component';
import { ContentWrapperComponent } from '@shared/content-wrapper/content-wrapper.component';

@Component({
    selector: 'companyid-business-goal',
    imports: [NgOptimizedImage, AssetPipe, BusinessGoalButtonsComponent, ContentWrapperComponent],
    templateUrl: './business-goal.component.html',
    styleUrl: './business-goal.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BusinessGoalComponent {
    public readonly businessGoals: BusinessGoal[] = [
        {
            imgPath: 'reduce',
            title: $localize`:@@business-goal-title-reduce:Reduce`,
            subtitle: $localize`:@@business-goal-subtitle-reduce:Reduce the time required for data entry and tracking by more than 30% compared to other systems.`,
        },
        {
            imgPath: 'provide',
            title: $localize`:@@business-goal-title-provide:Provide`,
            subtitle: $localize`:@@business-goal-subtitle-provide:Provide real-time access to critical business data for timely decision-making`,
        },
        {
            imgPath: 'enhance',
            title: $localize`:@@business-goal-title-enhance:Enhance`,
            subtitle: $localize`:@@business-goal-subtitle-enhance:Enhance operational efficiency and productivity.`,
        },
    ];
}
